module.exports = __webpack_public_path__ + "img/bg1.39eb47b3.png";